// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"398":"93045a63","472":"2a2d4bc6","858":"be09ddda"}[chunkId] + ".chunk.js";
};